<template>
  <div class="facebook-report">
    <!-- 时间控制 -->
    <el-col class="date-control">
      <date-control
        platForm="backend"
        :serviceId="serviceId"
        :websiteList="websiteList"
        :avatarUrl="avatarUrl"
        :pickerType="pickerType"
        :selecttimetype="selecttimetype"
        :format="format"
        :startDate="startDate"
        :endDate="endDate"
        :disabled="disabled"
        @changeSite="changeSite"
        @change="change"
        @dataChange="dataChange"
      ></date-control>
    </el-col>
    <!-- 数据总览 -->
    <el-col class="data-overview">
      <data-overview
        :dataPeriod="dataPeriod"
        :googleadvertising="googleadvertising"
      ></data-overview>
    </el-col>
    <!-- charts -->
    <el-col class="report-chart">
      <report-charts
        :toolbar="toolbar"
        :tishiName="tishiName"
        :activeClass="activeClass"
        :activeName="activeName"
        :interpretation="interpretation"
        :condition="condition"
        :conditionPie="conditionPie"
        :condition-audience="audienceData"
        :dataList="dataList"
        :column="column"
        :loading="loading"
        :loading-audience="loading_audience"
        @handleClick="handleClick"
        @setselectNum="setselectNum"
        @setselectNumPie="setselectNumPie"
        @googlederive="googlederive"
      ></report-charts>
    </el-col>
  </div>
</template>

<script>
import dateControl from '@/components/report/report-date-control.vue'
import dataOverview from '@/components/report/report-data-overview.vue'
import reportCharts from '@/components/report/report-charts.vue'
import createDateControl from '@/components/report/createDateControl.js'
import createDataOverview from '@/components/report/createDataOverview.js'
import createReportCharts from '@/components/report/createReportCharts.js'
import fbSer from '@/backend/services/facebook/fbSer.js'
import { mapGetters } from 'vuex'

let dateControlMixins = createDateControl()
let dataOverviewMixins = createDataOverview()
let reportChartsMixins = createReportCharts(fbSer)

export default {
  name: 'facebookReport',
  components: {
    dateControl,
    dataOverview,
    reportCharts,
  },
  mixins: [dateControlMixins, dataOverviewMixins, reportChartsMixins],
  data() {
    return {
      fbData: {},
      fbDataPie: {},
      audienceData: {},
      loading_audience: false,
    }
  },
  computed: {
    ...mapGetters(['customerId']),
  },
  watch: {
    customerId: {
      async handler(val) {
        let id = this.$route.query.id
        let name = this.$route.query.name
        if (id && name) {
          this.$store.commit('SET_CUSTOMERID', id)
          this.$store.commit('SET_CUSOMERNAME', name)
        }

        if (val || (id && name)) {
          this.disabled = false
          this.getWebsite(val)
        } else {
          this.disabled = true
          this.$message.warning('您需要先选择一个客户')
          this.$showCustomerDialog()
          this.init()
        }
      },
      immediate: true,
    },
  },
  methods: {
    getChartDataAll() {
      this.getReportData()
      this.getReportDataPie()
      this.getAudienceReport()
    },

    async getReportData() {
      let { startDate, endDate, selecttimetype, selectNum, serviceId } = this
      // let temp = '512596584664399872'
      let param = {
        serviceId,
        startDate: startDate,
        endDate: endDate,
        type: selecttimetype,
        sortDTO: {
          field: selectNum,
          sort: 'DESC',
        },
      }
      try {
        let res = await fbSer.reportData(param, serviceId)
        this.fbData = res.data
        let listName = this.activeClass + 'StatisticsList'
        this.dataList = this.fbData[listName]
        this.setFBadvertising(res.data) //账户概览数据
        this.setCondition() //图表数据
        this.setConditionPie()
        this.setColumn(this.activeName) //列表数据
      } catch (e) {
        console.error(e)
        this.fbData = {}
        this.avatarUrl = ''
        this.setFBadvertising()
        this.setCondition()
        this.setConditionPie()
        this.dataList = []
      }
    },

    async getReportDataPie() {
      let { startDate, endDate, selecttimetype, selectNumPie, serviceId } = this
      let param = {
        serviceId,
        startDate: startDate,
        endDate: endDate,
        type: selecttimetype,
        sortDTO: {
          field: selectNumPie,
          sort: 'DESC',
        },
      }
      try {
        let res = await fbSer.reportData(param, serviceId)
        this.fbDataPie = res.data
        this.setConditionPie()
      } catch (e) {
        console.error(e)
        this.fbDataPie = {}
      }
    },
    async getWebsite(id) {
      let res = await fbSer.pageList({
        customerId: id,
      })
      if (res && res.data && res.data.length) {
        this.serviceId = res.data[0].serviceId
        this.avatarUrl = res.data[0].pageAvatar
        this.websiteList = res.data
        this.getWeek()
      } else {
        this.serviceId = ''
        this.websiteList = []
      }
    },

    // 受众报告
    async getAudienceReport() {
      this.loading_audience = true
      let { startDate, endDate, selecttimetype, selectNum, serviceId } = this
      let param = {
        serviceId,
        startDate,
        endDate,
        type: selecttimetype,
        sortDTO: {
          field: selectNum,
          sort: 'DESC',
        },
      }
      try {
        let res = await fbSer.audienceReport(param)
        this.audienceData = res.data
        this.loading_audience = false
      } catch (e) {
        this.loading_audience = false
        console.error(e)
      }
    },
    init() {
      this.serviceId = ''
      this.avatarUrl = ''
      this.websiteList = []
      this.dataList = []
      this.fbData = {}
      this.setFBadvertising()
      this.setCondition()
      this.setConditionPie()
    },
  },
  mounted() {
    this.setFBadvertising()
  },
}
</script>

<style lang="scss" scoped>
.facebook-report::after {
  content: '';
  display: block;
  clear: both;
  overflow: hidden;
}
.data-overview {
  margin-top: 10px;
}
.report-chart {
  margin-top: 10px;
}
</style>
